import * as React from 'react'
import { Container } from 'reactstrap'
import './Main.css'

interface ExperienceProps {
  duration: string
  title: string
  company: string
  description: string
}

class Experience extends React.Component<ExperienceProps, {}> {
  render() {
    let { duration, title, company, description } = this.props

    return (
      <div>
        <h5><strong>{title}</strong></h5>
        <div>{company} <span className="duration-time">[{duration}]</span> </div>
        {/* <div className="black-light">{duration}</div> */}
        <div className="medium-text" dangerouslySetInnerHTML={{ __html: description }} />
        <div>-----</div>
      </div>
    )
  }
}

interface SkillProps {
  header: string
  description: string
}

class Skill extends React.Component<SkillProps, {}> {
  render() {
    let { header, description } = this.props

    return (
      <div>
        <h5>{header}</h5>
        <div className="medium-text" dangerouslySetInnerHTML={{ __html: description }} />
        <div>-----</div>
      </div>
    )
  }
}

interface SimpleProps {
  header: string
  description: string
}

class Simple extends React.Component<SimpleProps, {}> {
  render() {
    let { header, description } = this.props

    return (
      <div>
        <h2 className="title-section">{header}</h2>
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    )
  }
}

export default class Main extends React.Component {
  render() {
    return (
      <Container className="App-body">
        {/* Summary session */}
        <section className="App-section" data-aos="fade-up" data-aos-duration="4000">
          <Simple
            header={'About me'}
            description={`
              <div>
                <p>
                I am a young man, who desires to do more research and study to be a geek in Information Technology field. And I am willing to face difficulties and try my best to overcome all the obstacles.
                <br/>
                "Never give up. Today is hard, tomorrow will be worse, but the day after tomorrow will be sunshine." Jack Ma
                </p>
                <b>Highlights</b>
                <br />
                <ul>
                  <li>Logical thinking skills.</li>
                  <li>Enjoy designing systems and solving algorithmic problems.</li>
                  <li>Self-motivated with good team spirit.</li>
                  <li>Code profiling, diagnostics, troubleshooting and performance optimization.</li>
                  <li>A continuous learning attitude.</li>
                  <li>Passionate about tackling challenging architectural and scalability problems.</li>
                </ul>
              </div>
            `}
          />
        </section>
        <hr/>
        {/* Education session */}
        <section className="App-section" data-aos="fade-right" data-aos-duration="4000">
          <Simple
            header={'Education'}
            description={`
              <div>
                <p>
                University of Information Technology – VNU HCMC <br/>
                Bachelor of Science in Information Technology (Rank: 1/54) <br/>
                Thesis: Object counting in static images using Deep Learning (Thesis score: 9.2/10)
                </p>
              </div>
            `}
          />
        </section>
        <hr/>
        {/* Award session */}
        <section className="App-section" data-aos="fade-right" data-aos-duration="4000">
          <Simple
            header={'Award'}
            description={`
              <div>
                <p>UIT Scholarship - 2015, 2016, 2017</p>
                <p>Consolation Prize in National Olympic Contest for IT Student - 2014</p>
                <p>First Prize of UIT-ACM - 2nd/2014, 4th/2015</p>
                <p>“Students of 5 merits” by the University of Information Technology in 2016</p>
                <p>Second Prize of UIT-ACM 6th - 2016</p>
                <p>Third Prize in National Olympic Contest for IT Students - 2016</p>
                <p>Third Prize of UIT-ACM 7th - 2017</p>
              </div>
            `}
          />
        </section>
        <hr/>
        {/* Experience session */}
        <section className="App-section" data-aos="fade-right" data-aos-duration="4000">
          <h2 className="title-section">Experience</h2>
          <Experience
            duration={'Jun 2016 – July 2017'}
            title={'Student'}
            company={'MMLAP - UIT'}
            description={`Research about machine learning, especially in using state-of-the-art Deep Learning methods for objects counting task.`}
          />
          <Experience
            duration={'Jun 2017 - Jun 2018'}
            title={'Software Developer'}
            company={'Planet'}
            description={`<p>
            Build a network tool able to send custom TCP/UDP packets, designed to perform "Stress Testing". <br/>
            Participate in the development and optimization of cross-platform chat system for internal. 
            </p>
           `}
          />
          <Experience
            duration={'Jun 2018 - Present'}
            title={'Software Developer'}
            company={'Zalo - VNG Corporation'}
            description={`
            <p>
            Participate in developing and building some features for media system of Zalo group. <br/>
            Build the Livestream system.
            </p>
            `}
          />
        </section>
        <hr/>
        <section className="App-section" data-aos="fade-right" data-aos-duration="4000">
          <h2 className="title-section">Skills</h2>
          
          <div>
            <Skill
              header={'Software development'}
              description={`
              <p>
              <strong>Backend:</strong> Java, C/C++, Apache Thrift. <br/>
              <strong>Frontend:</strong> Html, Css, Javascript, Bootstrap, jQuery, Gulp, Scss, ReactJS. <br/>
              <strong>Desktop App:</strong> Java Swing, Qt/QML. <br/>
              <strong>Database:</strong> SQL(MySql, Sql Server, Sqlite), NoSQL.
              </p>
            `}
            />
            <Skill
              header={'Problem solving'}
              description={`
              <p>
                Data structures and algorithms skill, Competitive Programming.
              </p>`}
            />
            <Skill
              header={'OS/System'}
              description={`Linux, Windows, MacOS, Nginx.`}
            />

            <Skill
              header={'AI'}
              description={`Machine learning and Deep learning.`}
            />
            <Skill
              header={'Version control'}
              description={`
              <p>
              GitHub, GitLab, SVN.
              </p>
            `}
            />
          </div>
        </section>
        <hr/>
        <section className="App-section" data-aos="fade-up" data-aos-duration="4000">
          <Simple
            header={'Certification'}
            description={`
              <div>
                <p>The 2013 ACM-ICPC Programming Contest Asia Danang Regional</p>
                <p>The 2014 ACM-ICPC Programming Contest Vietnam National Round</p>
                <p>The 2016 ACM-ICPC Programming Contest Asia Nhatrang Regional</p>
              </div>
            `}
          />
        </section>
        <hr/>
        <section className="App-section" data-aos="fade-right" data-aos-duration="4000">
          <Simple
            header={'Interests'}
            description={`
              <div>
                <p>Technology, History, Psychology</p>
                <p>Reading</p>
                <p>Sports (football, badminton, Table football)</p>
              </div>
            `}
          />
        </section>
        <hr/>
        <section className="App-section" data-aos="fade-right" data-aos-duration="4000">
          <Simple
            header={'Social'}
            description={`
              <div>
                <a href="https://www.facebook.com/ducctqb" target="_blank">
                    <i class="fab fa-facebook-square fa-lg w3-hover-opacity">Facebook</i>
                </a>
                <br/>
                <a href="https://medium.com/@ntduc95" target="_blank">
                    <i class="fab fa-medium fa-lg w3-hover-opacity">Medium</i>
                </a>
                <br/>
                <a href="https://twitter.com/ntduc95" target="_blank">
                    <i class="fab fa-twitter-square fa-lg w3-hover-opacity">Twitter</i>
                </a>
                <br/>
                <a href="https://www.linkedin.com/in/nguyen-trung-duc-49a3a0135/" target="_blank">
                    <i class="fab fa-linkedin fa-lg w3-hover-opacity">Linkedin</i>    
                </a>
                <br/>
                <a href="https://github.com/nguyentrungduc08" target="_blank">
                    <i class="fab fa-github-square fa-lg w3-hover-opacity">Github</i>
                </a>
                <br/>
                <a href="https://www.hackerrank.com/ducnt?hr_r=1" target="_blank">
                    <i class="fab fa-github-square fa-lg w3-hover-opacity">Hackerrank</i>
                </a>
                <br/>
                <a href="https://www.goodreads.com/user/show/37672803-duc-nguyen" target="_blank">
                    <i class="fab fa-goodreads fa-lg w3-hover-opacity">Goodreads</i>
                </a>
              </div>
            `}
          />
        </section>
        <hr/>
        <section className="App-section" data-aos="fade-up" data-aos-duration="4000">
          <Simple
            header={'Contact'}
            description={`
              <div>
                <p>
                  Email: <a href="mailto: nguyentrungduc08@gmail.com">nguyentrungduc08@gmail.com</a>
                </p>
                <p>
                  Phone: <a href="tel:+84966204011">(+84) 966 204 011</a>
                </p>
              </div>
            `}
          />
        </section>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Component/Main.tsx